import React, { useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useProjectProvider } from "../../../../Providers/Client/Project";
import { Avatar, AvatarGroup } from "@mui/material";
import { stringAvatar } from "../../../../Utils/avatar";
import CustomTable from "../../../../Components/Table";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userPermissions } from "../../../../Utils/constants";

function createData(Id, Date, Project, Description, Consultants, Vendors) {
  return {
    Id,
    Date,
    Project,
    Description,
    Consultants,
    Vendors,
  };
}

const headCells = [
  { label: "Project Date", disablePadding: true },
  { label: "Project" },
  { label: "Description" },
  { label: "Consultants" },
  { label: "Vendors" },
];

export default function Projects({ setProjectStatus }) {
  const [rows, setRows] = React.useState([]);
  const { projectsWithProfiles, fetchAllProjectsWithProfiles } =
    useProjectProvider();
    const permissions = useSelector((state) => state.user.permissions);
  const navigate = useNavigate()

  useEffect(() => {
    fetchAllProjectsWithProfiles();
  }, []);

  useEffect(() => {
    setRows(
      projectsWithProfiles.map((project) =>
        createData(
          project.id,
          moment.utc(project.createdAt).format("DD-MM-YYYY"),
          project.title,
          project.description,
          project.consultants,
          project.vendors
        )
      )
    );
  }, [projectsWithProfiles]);

  const CustomRow = ({ row }) => {
    return (
      <TableRow
        hover
        onClick={() => {
          // setProject({
            //   ...project,
            //   id: row.Id,
            //   name: row.Project,
            //   description: row.Description,
            // });
            if(permissions?.includes(`admin-client`) ||
            permissions?.includes(userPermissions.job.timesheetAction)){
            setProjectStatus(true);
            navigate(`project/${row?.Id}`)
          }
        }}
        tabIndex={-1}
        key={row.Id}
        className="cursor-pointer"
      >
        <TableCell padding="none" component="th" scope="row">
          {row.Date}
        </TableCell>
        <TableCell className="truncate max-w-[250px]" align="left">{row.Project}</TableCell>
        <TableCell className="truncate max-w-[250px]" align="left">{row.Description}</TableCell>
        <TableCell align="left">
          <div className="flex flex-row items-center">
            <AvatarGroup max={3}>
              {row.Consultants?.map((consultant) => (
                <Avatar
                  key={consultant?.id}
                  {...stringAvatar(
                    `${consultant?.firstName} ${consultant?.lastName}`
                  )}
                />
              ))}
            </AvatarGroup>
          </div>
        </TableCell>
        <TableCell align="left">
          <div className="flex flex-row items-center">
            <AvatarGroup max={3}>
              {row.Vendors?.map((vendor) => (
                <Avatar
                  key={vendor?.id}
                  {...stringAvatar(`${vendor?.firstName} ${vendor?.lastName}`)}
                />
              ))}
            </AvatarGroup>
          </div>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <div className="py-4">
      <CustomTable
        title="Ongoing Projects"
        headCells={headCells}
        rows={rows}
        CustomRow={CustomRow}
        showDensePadding={false}
      />
    </div>
  );
}
